
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// The fluid simulation implementation here follows the Real-Time Fluid Dynamics paper by Jos Stam.
// http://graphics.cs.cmu.edu/nsp/course/15-464/Fall09/papers/StamFluidforGames.pdf
// @ts-ignore because Parcel handles this import.
var $444a1f9845a7b67c$exports = {};
$444a1f9845a7b67c$exports = "#version 100\nprecision highp float;\n#define GLSLIFY 1\n\nattribute vec2 position;\nvarying vec2 cell_center;\n\nvoid main() {\n    cell_center = (position + 1.0) / 2.0;\n    gl_Position = vec4(position, 0, 1);\n}\n";


var $4407b64e9cb6b8b7$exports = {};
$4407b64e9cb6b8b7$exports = "// The fluid simulation implementation here follows the Real-Time Fluid Dynamics paper by Jos Stam.\n// http://graphics.cs.cmu.edu/nsp/course/15-464/Fall09/papers/StamFluidforGames.pdf\n\n#version 100\nprecision mediump float;\n#define GLSLIFY 1\n\n#define DEBUG_VELOCITY 0\n\n// Instead of a separate shader program for each rendering pass, we use one program with a uniform\n// variable as a pass discriminator.\nconst int COPY_PASS_KIND = 0;\nconst int DENSITY_SOURCE_PASS_KIND = 1;\nconst int DENSITY_DIFFUSION_PASS_KIND = 2;\nconst int DENSITY_ADVECTION_PASS_KIND = 3;\nconst int VELOCITY_SOURCE_PASS_KIND = 4;\nconst int VELOCITY_DIFFUSION_PASS_KIND = 5;\nconst int VELOCITY_ADVECTION_PASS_KIND = 6;\nconst int VELOCITY_PROJECTION_STEP_1_PASS_KIND = 7;\nconst int VELOCITY_PROJECTION_STEP_2_PASS_KIND = 8;\nconst int VELOCITY_PROJECTION_STEP_3_PASS_KIND = 9;\nuniform int pass_kind;\n\n// These textures have semantics depending on the render pass kind. \nuniform sampler2D texture_0;\nuniform sampler2D texture_1;\n\nuniform float cell_size;\nuniform float diffusion_rate;\nuniform float dissipation_rate;\nuniform float dt;\n\nvarying vec2 cell_center;\n\nvec3 rgb_from_hsv(const vec3 color) {\n    // https://stackoverflow.com/a/17897228\n    vec4 K = vec4(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);\n    vec3 p = abs(fract(color.xxx + K.xyz) * 6.0 - K.www);\n    return color.z * mix(K.xxx, clamp(p - K.xxx, 0.0, 1.0), color.y);\n}\n\nvec3 cell(const sampler2D texture, const int i, const int j) {\n    // Use a modulo on the coordinate so the grid wraps around itself.\n    vec2 texel_coordinate = mod((vec2(i, j) + 0.5) * cell_size, 1.0);\n    return texture2D(texture, texel_coordinate).xyz;\n}\nvec3 cell(const int i, const int j) {\n    return cell(texture_0, i, j);\n}\n\nvec2 velocity(const vec3 texel) {\n    return texel.xy;\n}\nvec2 velocity(const sampler2D texture, const int i, const int j) {\n    return velocity(cell(texture, i, j));\n}\nvec2 velocity(const int i, const int j) {\n    return velocity(cell(i, j));\n}\n\nfloat density(const vec3 texel) {\n    return texel.z;\n}\nfloat density(const sampler2D texture, const int i, const int j) {\n    return density(cell(texture, i, j));\n}\nfloat density(const int i, const int j) {\n    return density(cell(i, j));\n}\n\nvec3 diffusion(const int i, const int j) {\n    float grid_size = 1.0 / cell_size;\n    float diffusion_factor = diffusion_rate * grid_size * grid_size * dt;\n    vec3 pre_diffusion_cell = cell(texture_1, i, j);\n    return (\n        pre_diffusion_cell +\n        diffusion_factor * (cell(i - 1, j) + cell(i + 1, j) + cell(i, j - 1) + cell(i, j + 1))) /\n        (1.0 + 4.0 * diffusion_factor);\n}\n\nvec3 advection(const int i, const int j) {\n    float grid_size = 1.0 / cell_size;\n    vec2 backtrace = clamp(vec2(i, j) - velocity(i, j) * grid_size * dt, 0.5, grid_size - 0.5);\n    ivec2 ij_0 = ivec2(floor(backtrace));\n    ivec2 ij_1 = ij_0 + 1;\n    vec2 st_1 = backtrace - vec2(ij_0);\n    vec2 st_0 = 1.0 - st_1;\n    return st_0.x * (st_0.y * cell(ij_0.x, ij_0.y) + st_1.y * cell(ij_0.x, ij_1.y)) +\n        st_1.x * (st_0.y * cell(ij_1.x, ij_0.y) + st_1.y * cell(ij_1.x, ij_1.y));\n}\n\nvec2 projection_step_1(const int i, const int j) {\n    float div =  -0.5 * cell_size * (\n        velocity(i + 1, j).x - velocity(i - 1, j).x +\n        velocity(i, j + 1).y - velocity(i, j - 1).y);\n    return vec2(div, 0);\n}\n\nvec2 projection_step_2(const int i, const int j) {\n    float div = cell(i, j).x;\n    float p = (\n        div + \n        cell(i - 1, j).y + cell(i + 1, j).y + \n        cell(i, j - 1).y + cell(i, j + 1).y) / 4.0;\n    return vec2(div, p);\n}\n\nvec2 projection_step_3(const int i, const int j) {\n    return velocity(i, j) - 0.5 * vec2(\n        cell(texture_1, i + 1, j).y - cell(texture_1, i - 1, j).y, \n        cell(texture_1, i, j + 1).y - cell(texture_1, i, j - 1).y) / cell_size;\n}\n\nvoid main() {\n    int i = int(cell_center.x / cell_size);\n    int j = int(cell_center.y / cell_size);\n\n    if (pass_kind == COPY_PASS_KIND) {\n        gl_FragColor = vec4(cell(i, j), 1);\n        return;\n    }\n\n    if (pass_kind == DENSITY_SOURCE_PASS_KIND) {\n        float source = density(texture_1, i, j);\n        float new_density = max(density(i, j) + (source - dissipation_rate) * dt, 0.0);\n        gl_FragColor = vec4(velocity(i, j), new_density, 1);\n        return;\n    }\n\n    if (pass_kind == DENSITY_DIFFUSION_PASS_KIND) {\n        gl_FragColor = vec4(velocity(i, j), density(diffusion(i, j)), 1);\n        return;\n    }\n\n    if (pass_kind == DENSITY_ADVECTION_PASS_KIND) {\n        gl_FragColor = vec4(velocity(i, j), density(advection(i, j)), 1);\n        return;\n    }\n\n    if (pass_kind == VELOCITY_SOURCE_PASS_KIND) {\n        vec2 source = velocity(texture_1, i, j);\n        vec2 new_velocity = velocity(i, j) + source * dt;\n        if (length(new_velocity) > 0.001) {\n            float new_speed = max(length(new_velocity) - dissipation_rate * dt, 0.0);\n            new_velocity = normalize(new_velocity) * new_speed;\n        }\n        gl_FragColor = vec4(new_velocity, density(i, j), 1);\n        return;\n    }\n\n    if (pass_kind == VELOCITY_DIFFUSION_PASS_KIND) {\n        gl_FragColor = vec4(velocity(diffusion(i, j)), density(i, j), 1);\n        return;\n    }\n\n    if (pass_kind == VELOCITY_ADVECTION_PASS_KIND) {\n        gl_FragColor = vec4(velocity(advection(i, j)), density(i, j), 1);\n        return;\n    }\n\n    if (pass_kind == VELOCITY_PROJECTION_STEP_1_PASS_KIND) {\n        gl_FragColor = vec4(projection_step_1(i, j), 0, 1);\n        return;\n    }\n\n    if (pass_kind == VELOCITY_PROJECTION_STEP_2_PASS_KIND) {\n        gl_FragColor = vec4(projection_step_2(i, j), 0, 1);\n        return;\n    }\n\n    if (pass_kind == VELOCITY_PROJECTION_STEP_3_PASS_KIND) {\n        gl_FragColor = vec4(projection_step_3(i, j), density(i, j), 1);\n        return;\n    }\n\n#if DEBUG_VELOCITY\n    float grid_size = 100.0 * cell_size;\n    float hue = (degrees(atan(velocity(i, j).y, velocity(i, j).x)) + 180.0) / 360.0;\n    float value = min(length(velocity(i, j)) / grid_size, 1.0);\n    gl_FragColor = vec4(rgb_from_hsv(vec3(hue, 1, value)), 1);\n#else\n    float hue = (degrees(atan(velocity(i, j).y, velocity(i, j).x)) + 180.0) / 360.0;\n    float value = density(i, j);\n    gl_FragColor = vec4(rgb_from_hsv(vec3(hue, 1, value)), 1);\n#endif      \n}\n";


function $e01d6e1b57fe2feb$export$b432d2a391137a85(gl) {
    const error_code = gl.getError();
    if (error_code == gl.NO_ERROR) return;
    const error_name = error_code == gl.INVALID_ENUM ? "INVALID_ENUM" : error_code == gl.INVALID_VALUE ? "INVALID_VALUE" : error_code == gl.INVALID_OPERATION ? "INVALID_OPERATION" : error_code == gl.INVALID_FRAMEBUFFER_OPERATION ? "INVALID_FRAMEBUFFER_OPERATION" : error_code == gl.OUT_OF_MEMORY ? "OUT_OF_MEMORY" : error_code == gl.CONTEXT_LOST_WEBGL ? "CONTEXT_LOST_WEBGL" : "unknown";
    throw new Error(`WebGL ${error_name} error (code ${error_code}).`);
}
function $e01d6e1b57fe2feb$export$9c3153902b5cadb5(gl, source, shader_type) {
    const shader_type_name = shader_type == gl.VERTEX_SHADER ? "vertex" : shader_type == gl.FRAGMENT_SHADER ? "fragment" : `type-${shader_type}`;
    const shader = gl.createShader(shader_type);
    if (!shader) {
        console.error(`Failed to create ${shader_type_name} shader.`);
        return null;
    }
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        console.error(`Failed to compile ${shader_type_name} shader: ${gl.getShaderInfoLog(shader)}`);
        return null;
    }
    $e01d6e1b57fe2feb$export$b432d2a391137a85(gl);
    return shader;
}
function $e01d6e1b57fe2feb$export$f1b60f3667a0b5d(gl, program, name) {
    const location = gl.getAttribLocation(program, name);
    if (location < 0) console.error(`Failed to get location for attribute '${name}'.`);
    return location;
}
function $e01d6e1b57fe2feb$export$1b21c09da1b82d01(gl, program, name) {
    const location = gl.getUniformLocation(program, name);
    if (!location) console.error(`Failed to get location for uniform '${name}'.`);
    return location;
}
function $e01d6e1b57fe2feb$export$47407766e6f157ce(gl, width, height, pixels) {
    if (pixels && width * height * 4 != pixels.length) {
        console.error("Pixel array size does not match texture dimensions.");
        return null;
    }
    const texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texParameterf(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
    gl.texParameterf(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
    gl.texParameterf(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameterf(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, width, height, 0, gl.RGBA, gl.FLOAT, pixels);
    $e01d6e1b57fe2feb$export$b432d2a391137a85(gl);
    return texture;
}
function $e01d6e1b57fe2feb$export$200c13bdb863a92c(gl, texture, x, y, width, height, pixels) {
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texSubImage2D(gl.TEXTURE_2D, 0, x, y, width, height, gl.RGBA, gl.FLOAT, pixels);
}


const $630c8bccf7fa832a$var$show_fps = false;
const $630c8bccf7fa832a$var$debug = false;
function $630c8bccf7fa832a$var$debug_assert_ok(gl) {
    if ($630c8bccf7fa832a$var$debug) (0, $e01d6e1b57fe2feb$export$b432d2a391137a85)(gl);
}
var $630c8bccf7fa832a$var$PassKind;
/// Instead of a separate shader program for each rendering pass, we use one program with a uniform
/// index variable as a pass discriminator.
(function(PassKind) {
    PassKind[PassKind["Copy"] = 0] = "Copy";
    PassKind[PassKind["DensitySource"] = 1] = "DensitySource";
    PassKind[PassKind["DensityDiffusion"] = 2] = "DensityDiffusion";
    PassKind[PassKind["DensityAdvection"] = 3] = "DensityAdvection";
    PassKind[PassKind["VelocitySource"] = 4] = "VelocitySource";
    PassKind[PassKind["VelocityDiffusion"] = 5] = "VelocityDiffusion";
    PassKind[PassKind["VelocityAdvection"] = 6] = "VelocityAdvection";
    PassKind[PassKind["VelocityProjectionStep1"] = 7] = "VelocityProjectionStep1";
    PassKind[PassKind["VelocityProjectionStep2"] = 8] = "VelocityProjectionStep2";
    PassKind[PassKind["VelocityProjectionStep3"] = 9] = "VelocityProjectionStep3";
    PassKind[PassKind["Visualization"] = 10] = "Visualization";
})($630c8bccf7fa832a$var$PassKind || ($630c8bccf7fa832a$var$PassKind = {}));
const $630c8bccf7fa832a$var$brush_radius = 8;
const $630c8bccf7fa832a$var$brush_size = 2 * $630c8bccf7fa832a$var$brush_radius;
function $630c8bccf7fa832a$var$set_brush_pixels(pixels, velocity_x, velocity_y, density) {
    if (pixels.length != $630c8bccf7fa832a$var$brush_size * $630c8bccf7fa832a$var$brush_size * 4) {
        console.error("Array size doesn't match brush dimensions.");
        return false;
    }
    for(let i = 0; i < $630c8bccf7fa832a$var$brush_size; ++i)for(let j = 0; j < $630c8bccf7fa832a$var$brush_size; ++j){
        const distance_to_center_squared = (i - $630c8bccf7fa832a$var$brush_radius) * (i - $630c8bccf7fa832a$var$brush_radius) + (j - $630c8bccf7fa832a$var$brush_radius) * (j - $630c8bccf7fa832a$var$brush_radius);
        if (distance_to_center_squared > $630c8bccf7fa832a$var$brush_radius * $630c8bccf7fa832a$var$brush_radius) continue;
        const k = (i * $630c8bccf7fa832a$var$brush_size + j) * 4;
        pixels[k + 0] = velocity_x;
        pixels[k + 1] = velocity_y;
        pixels[k + 2] = density;
        pixels[k + 3] = 0;
    }
    return true;
}
function $630c8bccf7fa832a$var$begin_simulation(gl, program, flow_source, options) {
    gl.useProgram(program);
    const frame_buffer = gl.createFramebuffer();
    if (!frame_buffer) {
        console.error("Failed to create frame buffer.");
        return false;
    }
    const geometry_buffer = gl.createBuffer();
    if (!geometry_buffer) {
        console.error("Failed to create WebGL buffer.");
        return false;
    }
    const [_viewport_x, _viewport_y, viewport_width, viewport_height] = gl.getParameter(gl.VIEWPORT);
    if (viewport_width != viewport_height) {
        console.error(`Expected viewport to be square but it's ${viewport_width}x${viewport_height}.`);
        return false;
    }
    // These we set only once.
    gl.uniform1i((0, $e01d6e1b57fe2feb$export$1b21c09da1b82d01)(gl, program, "texture_0"), 0);
    gl.uniform1i((0, $e01d6e1b57fe2feb$export$1b21c09da1b82d01)(gl, program, "texture_1"), 1);
    gl.uniform1f((0, $e01d6e1b57fe2feb$export$1b21c09da1b82d01)(gl, program, "cell_size"), 1 / viewport_width);
    gl.uniform1f((0, $e01d6e1b57fe2feb$export$1b21c09da1b82d01)(gl, program, "dt"), 1 / 60);
    // These we'll be reusing.
    const diffusion_rate_uniform = (0, $e01d6e1b57fe2feb$export$1b21c09da1b82d01)(gl, program, "diffusion_rate");
    const dissipation_rate_uniform = (0, $e01d6e1b57fe2feb$export$1b21c09da1b82d01)(gl, program, "dissipation_rate");
    const pass_kind_uniform = (0, $e01d6e1b57fe2feb$export$1b21c09da1b82d01)(gl, program, "pass_kind");
    $630c8bccf7fa832a$var$debug_assert_ok(gl);
    // We'll be rendering two triangles that cover the entire viewport.
    const triangles = new Float32Array([
        -1,
        -1,
        -1,
        1,
        1,
        -1,
        1,
        -1,
        -1,
        1,
        1,
        1
    ]);
    gl.bindBuffer(gl.ARRAY_BUFFER, geometry_buffer);
    gl.bufferData(gl.ARRAY_BUFFER, triangles, gl.STATIC_DRAW);
    $630c8bccf7fa832a$var$debug_assert_ok(gl);
    const position_attribute = (0, $e01d6e1b57fe2feb$export$f1b60f3667a0b5d)(gl, program, "position");
    gl.enableVertexAttribArray(position_attribute);
    gl.vertexAttribPointer(position_attribute, 2, gl.FLOAT, false, 0, 0);
    $630c8bccf7fa832a$var$debug_assert_ok(gl);
    const zeroed_pixels = new Float32Array(viewport_width * viewport_height * 4);
    const blank_texture = (0, $e01d6e1b57fe2feb$export$47407766e6f157ce)(gl, viewport_width, viewport_height, zeroed_pixels);
    const texture_0 = (0, $e01d6e1b57fe2feb$export$47407766e6f157ce)(gl, viewport_width, viewport_height, zeroed_pixels);
    const texture_1 = (0, $e01d6e1b57fe2feb$export$47407766e6f157ce)(gl, viewport_width, viewport_height, zeroed_pixels);
    const texture_2 = (0, $e01d6e1b57fe2feb$export$47407766e6f157ce)(gl, viewport_width, viewport_height, zeroed_pixels);
    const texture_3 = (0, $e01d6e1b57fe2feb$export$47407766e6f157ce)(gl, viewport_width, viewport_height, zeroed_pixels);
    if (!blank_texture || !texture_0 || !texture_1 || !texture_2 || !texture_3) {
        console.error("Failed to initialize textures.");
        return false;
    }
    function draw_pass(pass_kind, input_0, input_1, output) {
        gl.uniform1i(pass_kind_uniform, pass_kind);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, input_0);
        gl.activeTexture(gl.TEXTURE1);
        gl.bindTexture(gl.TEXTURE_2D, input_1);
        if (output) {
            gl.bindFramebuffer(gl.FRAMEBUFFER, frame_buffer);
            gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, output, 0);
        } else gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        gl.drawArrays(gl.TRIANGLES, 0, 6);
        $630c8bccf7fa832a$var$debug_assert_ok(gl);
    }
    function copy(from, to) {
        draw_pass(0, from, null, to);
    }
    function add_density_sources(input_flow, source, output_flow) {
        gl.uniform1f(dissipation_rate_uniform, options.density_dissipation_rate);
        draw_pass(1, input_flow, source, output_flow);
    }
    function diffuse_density(input_flow, intermediate, output_flow) {
        copy(input_flow, intermediate);
        gl.uniform1f(diffusion_rate_uniform, options.density_diffusion_rate);
        let iteration_input = input_flow;
        let iteration_output = output_flow;
        for(let i = 0; i < options.nr_intermediate_iterations; ++i){
            draw_pass(2, iteration_input, intermediate, iteration_output);
            [iteration_input, iteration_output] = [
                iteration_output,
                iteration_input
            ];
        }
        // Swap back after the last iteration.
        [iteration_input, iteration_output] = [
            iteration_output,
            iteration_input
        ];
        // Ensure that at loop end the output texture contains the last iteration's output.
        if (iteration_output != output_flow) copy(iteration_output, output_flow);
    }
    function advect_density(input_flow, output_flow) {
        draw_pass(3, input_flow, null, output_flow);
    }
    function add_velocity_sources(input_flow, source, output_flow) {
        gl.uniform1f(dissipation_rate_uniform, options.velocity_dissipation_rate);
        draw_pass(4, input_flow, source, output_flow);
    }
    function diffuse_velocity(input_flow, intermediate, output_flow) {
        copy(input_flow, intermediate);
        gl.uniform1f(diffusion_rate_uniform, options.velocity_diffusion_rate);
        let iteration_input = input_flow;
        let iteration_output = output_flow;
        for(let i = 0; i < options.nr_intermediate_iterations; ++i){
            draw_pass(5, iteration_input, intermediate, iteration_output);
            [iteration_input, iteration_output] = [
                iteration_output,
                iteration_input
            ];
        }
        // Swap back after the last iteration.
        [iteration_input, iteration_output] = [
            iteration_output,
            iteration_input
        ];
        // Ensure that at loop end the output texture contains the last iteration's output.
        if (iteration_output != output_flow) copy(iteration_output, output_flow);
    }
    function advect_velocity(input_flow, output_flow) {
        draw_pass(6, input_flow, null, output_flow);
    }
    function project_velocity(input_flow, intermediate, output_flow) {
        draw_pass(7, input_flow, null, intermediate);
        let iteration_input = intermediate;
        let iteration_output = output_flow;
        for(let i = 0; i < options.nr_intermediate_iterations; ++i){
            draw_pass(8, iteration_input, null, iteration_output);
            [iteration_input, iteration_output] = [
                iteration_output,
                iteration_input
            ];
        }
        // Swap back after the last iteration.
        [iteration_input, iteration_output] = [
            iteration_output,
            iteration_input
        ];
        // Ensure that at loop end the intermediate texture contains the last iteration's output.
        if (iteration_output != intermediate) copy(iteration_output, intermediate);
        draw_pass(9, input_flow, intermediate, output_flow);
    }
    function visualize(flow) {
        draw_pass(10, flow, null, null);
    }
    // We'll be swapping these throughout. Using the output of one draw pass as input to the next.
    let input_flow = texture_0;
    let output_flow = texture_1;
    function swap_input_and_output() {
        [input_flow, output_flow] = [
            output_flow,
            input_flow
        ];
    }
    const source_flow = texture_2;
    const intermediate = texture_3;
    const source_brush_pixels = new Float32Array($630c8bccf7fa832a$var$brush_size * $630c8bccf7fa832a$var$brush_size * 4);
    const fps_element = document.getElementById("fps");
    const fps_stats = $630c8bccf7fa832a$var$show_fps && fps_element ? {
        previous_frame_time: Date.now(),
        recent_frame_rates: new Array(60),
        next_frame_rate_index: 0,
        element: fps_element
    } : null;
    const step_simulation = ()=>{
        copy(blank_texture, source_flow);
        if (flow_source.position && (flow_source.density > 0 || flow_source.needs_movement_processing)) {
            const region_x = Math.max(0, flow_source.position.x - $630c8bccf7fa832a$var$brush_radius);
            const region_y = Math.max(0, flow_source.position.y - $630c8bccf7fa832a$var$brush_radius);
            const region_width = Math.min(viewport_width - region_x, $630c8bccf7fa832a$var$brush_size);
            const region_height = Math.min(viewport_height - region_y, $630c8bccf7fa832a$var$brush_size);
            $630c8bccf7fa832a$var$set_brush_pixels(source_brush_pixels, flow_source.velocity.x, flow_source.velocity.y, flow_source.density);
            (0, $e01d6e1b57fe2feb$export$200c13bdb863a92c)(gl, source_flow, region_x, region_y, region_width, region_height, source_brush_pixels);
            flow_source.needs_movement_processing = false;
        }
        add_velocity_sources(input_flow, source_flow, output_flow);
        swap_input_and_output();
        diffuse_velocity(input_flow, intermediate, output_flow);
        swap_input_and_output();
        project_velocity(input_flow, intermediate, output_flow);
        swap_input_and_output();
        advect_velocity(input_flow, output_flow);
        swap_input_and_output();
        project_velocity(input_flow, intermediate, output_flow);
        swap_input_and_output();
        add_density_sources(input_flow, source_flow, output_flow);
        swap_input_and_output();
        diffuse_density(input_flow, intermediate, output_flow);
        swap_input_and_output();
        advect_density(input_flow, output_flow);
        visualize(output_flow);
        swap_input_and_output();
        if (fps_stats) {
            const this_frame_time = Date.now();
            const fps = 1000 / (this_frame_time - fps_stats.previous_frame_time);
            fps_stats.previous_frame_time = this_frame_time;
            fps_stats.recent_frame_rates[fps_stats.next_frame_rate_index] = fps;
            fps_stats.next_frame_rate_index += 1;
            fps_stats.next_frame_rate_index %= fps_stats.recent_frame_rates.length;
            if (fps_stats.next_frame_rate_index == 0) {
                const average_fps = fps_stats.recent_frame_rates.reduce((sum, item)=>sum + item) / fps_stats.recent_frame_rates.length;
                fps_stats.element.textContent = `FPS: ${Math.floor(average_fps)}`;
            }
        }
        requestAnimationFrame(step_simulation);
    };
    requestAnimationFrame(step_simulation);
    return true;
}
function $630c8bccf7fa832a$var$inject_initial_flow(flow_source, center_x, center_y, radius, nr_puffs, density, velocity, total_duration_ms) {
    return new Promise((resolve)=>{
        function inject_puff(index) {
            const angle = 2 * Math.PI / nr_puffs * index;
            flow_source.position = {
                x: center_x + Math.cos(angle) * radius,
                y: center_y + Math.sin(angle) * radius
            };
            flow_source.velocity = {
                x: Math.cos(angle) * velocity,
                y: Math.sin(angle) * velocity
            };
            flow_source.density = density;
            if (index + 1 < nr_puffs) setTimeout(()=>inject_puff(index + 1), total_duration_ms / nr_puffs);
            else {
                flow_source.density = 0;
                resolve();
            }
        }
        inject_puff(0);
    });
}
function $630c8bccf7fa832a$var$setup_user_flow_source(flow_source, canvas) {
    const pointer_position = (event)=>{
        // Flip Y to match WebGL texture convention where zero is at the bottom.
        return {
            x: event.clientX - canvas.offsetLeft,
            y: canvas.clientHeight - (event.clientY - canvas.offsetTop)
        };
    };
    canvas.addEventListener("pointerdown", (event)=>{
        flow_source.position = pointer_position(event);
        flow_source.density = 50;
        canvas.setPointerCapture(event.pointerId);
    });
    canvas.addEventListener("pointerup", (event)=>{
        flow_source.density = 0;
        canvas.releasePointerCapture(event.pointerId);
    });
    canvas.addEventListener("pointermove", (event)=>{
        const previous_position = Object.assign(pointer_position(event), flow_source.position);
        flow_source.position = pointer_position(event);
        flow_source.velocity.x = flow_source.position.x - previous_position.x;
        flow_source.velocity.y = flow_source.position.y - previous_position.y;
        flow_source.needs_movement_processing = true;
    });
}
function $630c8bccf7fa832a$var$setup() {
    const canvas = document.getElementById("demo-canvas");
    if (!(canvas instanceof HTMLCanvasElement)) {
        console.error(`Expected a canvas element but got ${typeof canvas} instead.`);
        return false;
    }
    // Match resolution to occupied space.
    canvas.width = canvas.clientWidth;
    canvas.height = canvas.clientHeight;
    const gl = canvas.getContext("webgl", {
        alpha: false
    });
    if (!gl) {
        console.error("Failed to get WebGL rendering context.");
        return false;
    }
    for (const extension of [
        "OES_texture_float",
        "WEBGL_color_buffer_float"
    ])if (!gl.getExtension(extension)) {
        console.error(`Required WebGL extension '${extension}' is unsupported.`);
        return false;
    }
    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
    const vertex_shader = (0, $e01d6e1b57fe2feb$export$9c3153902b5cadb5)(gl, (0, (/*@__PURE__*/$parcel$interopDefault($444a1f9845a7b67c$exports))), gl.VERTEX_SHADER);
    if (!vertex_shader) {
        console.error("Failed to compile vertex shader.");
        return false;
    }
    const fragment_shader = (0, $e01d6e1b57fe2feb$export$9c3153902b5cadb5)(gl, (0, (/*@__PURE__*/$parcel$interopDefault($4407b64e9cb6b8b7$exports))), gl.FRAGMENT_SHADER);
    if (!fragment_shader) {
        console.error("Failed to compile fragment shader.");
        return false;
    }
    const program = gl.createProgram();
    if (!program) {
        console.error("Failed to create WebGL program.");
        return false;
    }
    gl.attachShader(program, vertex_shader);
    gl.attachShader(program, fragment_shader);
    gl.linkProgram(program);
    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
        console.error(`Failed to link WebGL program: ${gl.getProgramInfoLog(program)}`);
        return false;
    }
    $630c8bccf7fa832a$var$debug_assert_ok(gl);
    const flow_source = {
        position: null,
        velocity: {
            x: 0,
            y: 0
        },
        density: 0,
        needs_movement_processing: false
    };
    const options = {
        density_diffusion_rate: 0.00001,
        density_dissipation_rate: 0.01,
        velocity_diffusion_rate: 0,
        velocity_dissipation_rate: 0.0001,
        nr_intermediate_iterations: 20
    };
    if (!$630c8bccf7fa832a$var$begin_simulation(gl, program, flow_source, options)) {
        console.error("Simulation aborted.");
        return false;
    }
    $630c8bccf7fa832a$var$inject_initial_flow(flow_source, canvas.width / 2, canvas.height / 2, /* radius: */ canvas.width / 10, /* nr. puffs: */ 30, /* density: */ 100, /* velocity: */ 10, /* duration ms: */ 1000).then(()=>$630c8bccf7fa832a$var$setup_user_flow_source(flow_source, canvas));
    console.log("Simulation started.");
    return true;
}
window.addEventListener("DOMContentLoaded", $630c8bccf7fa832a$var$setup, {
    once: true
});


//# sourceMappingURL=index.db03fce4.js.map
